taillightUx.controller('tuxFabMenuController',
    ['$scope',
        function ($scope) {

            $scope.openedGroup = -1;
            $scope.group = $('.tux-fab-group').length();
            $scope.initialShowRV = false;
            
            $scope.group = 1;
            $scope.isSet = function(checkGroup) {
                return this.group === checkGroup;
            };
            $scope.setTab = function(setTab) {
                $scope.tab = setTab;
            }

            return{

            };

        }]);
//
//if click make current group active and hide other group